export default __webpack_public_path__ + "static/media/loadingTrx.db6362d6.gif";